import React from 'react'
import PropTypes from 'prop-types'

const MainSection = props => {
    const { className, children, ...otherProps } = props

    return (
        <section
            {...otherProps}
            className={
                className ? `main--section ${className}` : 'main--section'
            }
        >
            {children}
        </section>
    )
}

MainSection.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
}

export { MainSection }
